module.exports = require("./objectWithoutProperties.js");


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/helpers/object-without-properties.js
// module id = 422
// module chunks = 168707334958949